import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"; // Import Link and useNavigate
import SearchBar from "../components/Common/SearchBar";
import ContentCard from "../components/Common/ContentCard";
import { useAuth } from "../contexts/AuthContext"; // Corrected useAuth import
import api from "../services/api"; // Import api service
import { bodyAreas } from '../constants/courseConstants.js'; // Import bodyAreas
// import { Cog8ToothIcon } from '@heroicons/react/24/outline'; // For an icon - currently unused

// const massageLevels = [ // Removed as level filter is being removed
//   "Semua Level", "Effleurage", "Petrissage", "Shaking", 
//   "Tapotement", "Friction", "Vibration"
// ];

export default function Home() {
  const navigate = useNavigate(); // Initialize useNavigate
  const [selectedArea, setSelectedArea] = useState(bodyAreas[0]);
  // const [selectedLevel, setSelectedLevel] = useState(massageLevels[0]); // Removed
  const { user, loading: authLoading } = useAuth(); // Use the auth hook
  const [currentSearchQuery, setCurrentSearchQuery] = useState(""); // Added for search

  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [errorCourses, setErrorCourses] = useState('');

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoadingCourses(true);
        setErrorCourses('');
        const response = await api.get('/courses'); // Fetch from /api/courses
        if (response.data && response.data.status === 'success') {
          setCourses(response.data.data.courses);
        } else {
          setErrorCourses('Gagal mengambil data kursus.');
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
        setErrorCourses(err.response?.data?.message || 'Terjadi kesalahan server saat mengambil kursus.');
      } finally {
        setLoadingCourses(false);
      }
    };

    fetchCourses();
  }, []);

  const userNameToDisplay = user ? (user.namaLengkap || user.email || "Pengguna") : "Pengguna";

  const handleSearch = (query) => {
    setCurrentSearchQuery(query); // Update search query state
  };

  // const handleLevelChange = (e) => { // Removed
  //   setSelectedLevel(e.target.value);
  // };
  
  // Filtering logic now uses 'area' and search query
  const filteredCourses = courses
    .filter(course => 
      (selectedArea === "Semua Area" || course.area === selectedArea)
    )
    .filter(course => 
      course.judul.toLowerCase().includes(currentSearchQuery.toLowerCase())
    );

  if (authLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-teraplus-accent"></div>
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section 
        className="relative w-full py-16 md:py-24 lg:py-32 overflow-hidden" 
        style={{ 
          backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)), url('/images/mockup.png')", 
          backgroundSize: 'cover', 
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-indigo-600/20"></div>
        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <div className="mb-6">
              <div className="w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                </svg>
              </div>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 text-white leading-tight">
              Selamat Datang, <span className="text-blue-200">{userNameToDisplay}</span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl max-w-3xl mx-auto mb-8 md:mb-10 text-blue-100 leading-relaxed">
              Video panduan lengkap & materi terstruktur untuk pemulihan optimal Anda.
            </p>
            <div className="max-w-xl mx-auto">
              <SearchBar 
                placeholder="Cari video, teknik, atau area tubuh..." 
                onSearch={handleSearch}
                variant="hero"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Content Selection Section */}
      <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Jelajahi Course
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Pilih area tubuh yang ingin Anda pelajari dan tingkatkan keterampilan Anda
            </p>
          </div>

          {/* Filter Buttons */}
          <div className="mb-10 md:mb-12 flex flex-wrap justify-center items-center gap-3 sm:gap-4">
            {bodyAreas.map(area => (
              <button
                key={area}
                onClick={() => setSelectedArea(area)}
                className={`px-6 py-3 text-sm font-medium rounded-xl transition-all duration-200 ease-in-out transform hover:scale-105
                  ${selectedArea === area 
                    ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-500/25' 
                    : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200 hover:border-blue-300 shadow-sm hover:shadow-md'
                  }`}
              >
                {area}
              </button>
            ))}
          </div>
          
          {/* Content Cards Grid */}
          {loadingCourses ? (
            <div className="flex justify-center items-center h-40">
              <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-lg">
                <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-blue-500 mr-3"></div>
                <span className="text-blue-700">Memuat kursus...</span>
              </div>
            </div>
          ) : errorCourses ? (
            <div className="text-center py-12">
              <div className="bg-red-50 rounded-xl p-8 max-w-md mx-auto">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                </div>
                <p className="text-red-700 font-medium">{errorCourses}</p>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
              {filteredCourses.length > 0 ? (
                filteredCourses.map((course) => (
                  <ContentCard
                    key={course.id}
                    title={course.judul}
                    category={`${course.area || 'General'}`}
                    imageSrc={course.imageSrc || `https://via.placeholder.com/400x225.png?text=${encodeURIComponent(course.judul)}`}
                    onViewClick={() => navigate(`/course/${course.slug || course.id}`)}
                  />
                ))
              ) : (
                <div className="col-span-full text-center py-12">
                  <div className="bg-gray-50 rounded-xl p-8 max-w-md mx-auto">
                    <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                      </svg>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Tidak ada kursus ditemukan</h3>
                    <p className="text-gray-600">
                      Tidak ada kursus yang sesuai dengan filter Anda atau belum ada kursus yang tersedia.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
